<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" parentStoreName="Additional_info"
    :submit="submit" :status="status" :breadcrumbs="[
      {
        text: 'Información y soporte',
        disabled: false,
        href: '/admin/additional_info'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: $route.params.id ? 'Editar' : 'Crear',
        disabled: true,
        href: '#'
      }
    ]">
    <ValidationObserver ref="validator" v-slot="{ }">
      <v-row no-gutters justify="center">
        <v-col cols="8">
          <v-row no-gutters>
            <v-col>
              <ValidationProvider ref="description" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Descripción</div>
                <v-textarea :error-messages="errors" v-model="data.description" solo placeholder="Descripción"
                  hide-details="auto" class="text-tarea-base" rows="8" />

              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row no-gutters class="mt-4">
            <v-col>
              <ValidationProvider ref="order" rules="non_negative" v-slot="{ errors }">
                <div class="label-base pb-1">Orden</div>
                <v-text-field :error-messages="errors" v-model="data.order" min="0" label="Orden" type="number" solo
                  hide-details="auto" class="input-base custom-number">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.order++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.order = Math.max(0, data.order - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  computed: {
    ...mapState({
      status: (state) => state.Additional_info.status,
    }),
  },
  data() {
    return {
      storeName: "Additional_info",
      title: "Información Adicional",
      data: {
        order: "",
        description: "",
      },
    };
  },
};
</script>
